import { useEffect, useRef } from 'react'
import type { Swiper as SwiperInstance } from 'swiper'

interface UseStorySwiperNavigationOptions {
	activeStoryIndex: number
	storyCount: number
	hasNextPage: boolean
	onLoadMore: () => Promise<boolean>
	wheelEnabled: boolean
}

export default function useStorySwiperNavigation({
	activeStoryIndex,
	storyCount,
	hasNextPage,
	onLoadMore,
	wheelEnabled,
}: UseStorySwiperNavigationOptions) {
	const storySwiperRef = useRef<SwiperInstance>(null)
	const canPreviousStory = activeStoryIndex > 0
	const canNextStory = activeStoryIndex < storyCount - 1 || hasNextPage
	const handlePreviousStory = () => storySwiperRef.current?.slidePrev()
	const handleNextStory = async () => {
		const swiper = storySwiperRef.current
		if (!swiper) return
		if (!swiper.isEnd) {
			swiper.slideNext()
			return
		}
		if (await onLoadMore()) {
			swiper.update()
			swiper.slideNext()
		}
	}
	const handleStorySwiper = (swiper: SwiperInstance) => {
		storySwiperRef.current = swiper
		if (!wheelEnabled) swiper.mousewheel.disable()
	}

	useEffect(() => {
		storySwiperRef.current?.mousewheel[wheelEnabled ? 'enable' : 'disable']()
	}, [wheelEnabled])

	return {
		handleStorySwiper,
		canPreviousStory,
		canNextStory,
		handlePreviousStory,
		handleNextStory,
	}
}
